import React from 'react'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import useLogout from '../../../hooks/useLogout'

const NoHcsLinked: React.FC = () => {
    const { loading, logout } = useLogout()
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1.5rem',
                alignItems: 'center',
            }}
        >
            <Typography fontSize="1.4rem" fontWeight="700">
                Aucun centre de santé n'est relié à vos identifiants.
            </Typography>
            <Button
                onClick={() => {
                    logout()
                }}
                variant="contained"
                disableElevation
                fullWidth
                startIcon={loading ? <CircularProgress /> : undefined}
            >
                {!loading ? "Retour à l'interface de connexion" : ''}
            </Button>
        </Box>
    )
}

export default NoHcsLinked
